/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/partials/tag.module.css';

const propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

function Tag({ className = null, children = null }) {
    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            {children}
        </div>
    );
}

Tag.propTypes = propTypes;

export default Tag;
